var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeD(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 236,
    viewBox: "0 0 273 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.469 202.786V139.597L55.2343 108L1 139.597V202.786L55.2343 234.383L109.469 202.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.469 96.7861V33.5972L116.234 2L62 33.5972V96.7861L116.234 128.383L170.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.469 96.7861V33.5972L241.234 2L187 33.5972V96.7861L241.234 128.383L295.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeD);
export default __webpack_public_path__ + "static/media/shape-d.7faf5cac.svg";
export { ForwardRef as ReactComponent };